import { Link } from 'react-router-dom';
import { TRIAL_DAYS } from '@alexiarest/shared';
import { useMe } from '../api/hooks';

/**
 * Cuantos dias de prueba quedan, siempre a la vista (mejora 52 de Alex,
 * 6 sep 2026): discreto arriba, con una barra que se va consumiendo. Con
 * tres dias o menos cambia el tono y ofrece elegir plan. Solo en prueba:
 * con suscripcion, o con el cerrojo Founder puesto, no hay nada que contar.
 */
export function diasDePrueba(trialEndsAt: string, ahora = Date.now()): number {
  const fin = Date.parse(trialEndsAt);
  if (!Number.isFinite(fin)) return 0;
  return Math.max(0, Math.ceil((fin - ahora) / 86_400_000));
}

export function TrialPill({ compacto = false }: { compacto?: boolean }): JSX.Element | null {
  const me = useMe();
  const tenant = me.data?.tenant;
  if (!tenant || tenant.subscriptionStatus !== 'trialing' || !tenant.trialEndsAt || tenant.founderPending) {
    return null;
  }
  const dias = diasDePrueba(tenant.trialEndsAt);
  const urgente = dias <= 3;
  const consumido = Math.min(100, Math.max(0, Math.round(((TRIAL_DAYS - dias) / TRIAL_DAYS) * 100)));
  const largo =
    dias === 0
      ? 'Tu prueba ha terminado'
      : urgente
        ? `Tu prueba termina en ${dias === 1 ? '1 día' : `${dias} días`}`
        : `Prueba gratuita · ${dias === 1 ? '1 día restante' : `${dias} días restantes`}`;
  const corto = dias === 0 ? 'Prueba terminada' : `${dias} ${dias === 1 ? 'día' : 'días'} de prueba`;

  return (
    <Link
      to="/ajustes?tab=plan"
      className={`trial-pill ${urgente ? 'trial-pill--urgente' : ''} ${compacto ? 'trial-pill--compacto' : ''}`.trim()}
      title={`${largo}. Elegir plan`}
      aria-label={`${largo}. Elegir plan`}
    >
      <span className="trial-pill__texto">
        <span className="trial-pill__largo">{largo}</span>
        <span className="trial-pill__corto">{corto}</span>
        {urgente && !compacto && <span className="trial-pill__cta">Elegir plan →</span>}
      </span>
      <span className="trial-pill__barra" aria-hidden="true">
        <span className="trial-pill__progreso" style={{ width: `${consumido}%` }} />
      </span>
    </Link>
  );
}
